import { TopNavigation } from '@/components/layout/TopNavigation';
import { SocialFeed } from '@/components/social/SocialFeed';
import { BottomNavigation } from '@/components/layout/BottomNavigation';

const Social = () => {
  return (
    <div className="min-h-screen w-screen pb-20" style={{ background: '#160C0C' }}>
      <TopNavigation variant="subtle" />
      
      <main className="pt-16 px-5">
        <div className="py-6">
          <SocialFeed />
        </div>
      </main>

      <BottomNavigation />
    </div>
  );
};

export default Social; 